import React, { Component } from "react";
import { Table, Card, Row, Col, Form, Image } from "react-bootstrap";
import ChangeDistributorStatus from "./ChangeDistributorStatus";
import DistributorDetailView from "./DistributorDetailView";

import "../Common/Common.css";

import ReactPaginate from "react-paginate";
var dateFormat = require("dateformat");

class Distributors extends Component {
  constructor(props) {
    super(props);
    this.state = {
      distributortoSearch: "",
      page: 0,
      perPage: 10,
      filterValue: "",
      showStatusChangeModel: false,
      showDetail: false
    };
  }

  componentDidMount() {
    this.props.fetchDistributors({
      pageno: undefined,
      queryToSearch: this.state.distributortoSearch,
      filter: this.state.filterValue
    });
  }

  changeDistributorStatus = item => {
    this.setState({
      showStatusChangeModel: true,
      distributorDetails: item
    });
  };

  closeStatusChangeModel = () => {
    this.setState({
      showStatusChangeModel: false
    });
  };

  handlePageClick = e => {
    const selectedPage = e.selected;
    this.props.pageSelected({
      pageno: selectedPage + 1,
      queryToSearch: this.state.distributortoSearch,
      filter: this.state.filterValue
    });
    this.setState({ page: selectedPage });
  };

  resetPage = () => {
    this.setState({ page: 0 });
  };

  SearchOnChange = event => {
    this.setState(
      {
        filterValue: "",
        page: 0,
        distributortoSearch: event.target.value
      },
      () => {
        this.props.fetchDistributors({
          pageno: undefined,
          queryToSearch: this.state.distributortoSearch,
          filter: ""
        });
      }
    );
  };

  handleChange = event => {
    this.setState(
      {
        filterValue: event.target.value,
        page: 0,
        distributortoSearch: ""
      },
      () => {
        this.props.fetchDistributors({
          pageno: undefined,
          queryToSearch: "",
          filter: this.state.filterValue
        });
      }
    );
  };

  viewDistributorDetail = item => {
    
    this.setState({
      showDetail: true,
      distributortoView: item
    });
    this.props.DistributorDetailView(item.item.id);
  };

  closeDetailView = () => {
    this.setState({
      showDetail: false
    });
  };

  render() {
    let p = this.state.page + 1;
    const count = this.props.DistributorsCount;
    let distributorsPageCount = Math.ceil(count / this.state.perPage);

    return (
      <div>
        <Card>
          <Card.Header>
            <Row className="w-100 align-items-center justify-content-between tableHeaderRow">
              <Col xs={12} sm={12} md={3} lg={3}>
                <h3>Distributors</h3>
              </Col>

              <Col xs={12} sm={12} md={3} lg={3}>
                <div className="commonFilterDiv">
                  <select
                    value={this.state.filterValue}
                    onChange={this.handleChange}
                    className="commonFilterSelect"
                  >
                    <option value="">All</option>
                    {/* <option value="created">Created</option> */}
                    <option value="active">Active</option>
                    <option value="suspended">Suspended</option>
                    {/* <option value="deleted">Deleted</option> */}
                  </select>
                </div>
              </Col>

              <Col xs={12} sm={12} md={3} lg={3}>
                <div>
                  <div className="commonInput">
                    <i className="fa fa-search fa-lg cmnSearchIcon"></i>
                    <input
                      type="text"
                      placeholder="User/Org/Mobile No"
                      value={this.state.distributortoSearch}
                      onChange={this.SearchOnChange}
                    />
                  </div>
                </div>
              </Col>
              <Col xs={12} sm={12} md={3} lg={3}>
                <div className="commonRecrd">
                  <i className="cui-note icons cmnRecordIcon"></i>
                  <span className="cmnPageCount">
                    {count !== undefined ? count : 0}
                  </span>
                  <span className="cmnResutText">Results</span>
                </div>
              </Col>
            </Row>
          </Card.Header>
          <Card.Body>
            <div>
              <Table responsive bordered striped className="cmnMainTable">
                <thead>
                  <tr className="cmnMainTableHd">
                    <th style={{ width: "70px" }}>SL NO</th>
                    <th>USER NAME</th>
                    <th>ORG NAME</th>
                    <th>MOBILE NUMBER</th>
                    <th>PROFILE UPDATE</th>
                    <th style={{ width: "100px" }}>STATUS</th>
                    <th>CREATED DATE</th>
                    <th style={{ width: "100px" }}>ACTION</th>
                  </tr>
                </thead>

                <tbody>
                  {this.props.DistributorsList &&
                    this.props.DistributorsList.map((item, i) => (
                      <tr key={i}>
                        <td>{10 * (p - 1) + i + 1}</td>
                        <td className="cmn_Cap">
                          {item !== null &&item.fullName?item.fullName:""}</td>
                          <td className="cmn_Cap">
                          {item !== null &&item.orgName?item.orgName:""}</td>
                        <td className="cmn_Cap">
                          {item !== null && item.mobileNo ? item.mobileNo : ""}
                        </td>
                        <td className="cmn_Cap">
                          {item !== null && item.ftLogin == true
                            ? "Pending"
                            : "Updated"}
                        </td>
                        <td className="cmn_Cap">
                          {item !== null && item.status == "active"
                            ? "Active"
                            : "Suspended"}
                        </td>

                        <td className="cmn_Cap">
                          {item.createdAt !== null &&
                            dateFormat(item.createdAt, "mediumDate")}
                        </td>
                        <td className="cmnViewIcon">
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center"
                            }}
                          >
                            <i
                              className="fa fa-eye fa-lg  "
                              onClick={() =>
                                this.viewDistributorDetail({ item: item })
                              }
                            ></i>

                            <i
                              className="fa fa-ban fa-lg "
                              style={{
                                paddingLeft: 10
                              }}
                              onClick={() =>
                                this.changeDistributorStatus({ item: item })
                              }
                            ></i>
                            <ChangeDistributorStatus
                              show={this.state.showStatusChangeModel}
                              closeModel={this.closeStatusChangeModel}
                              distributorDetails={this.state.distributorDetails}
                              ChangeStatus={this.props.ChangeStatus}
                              resetPage={this.resetPage}
                            />
                          </div>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </Table>

              <DistributorDetailView
                show={this.state.showDetail}
                close={this.closeDetailView}
                distributortoView={this.state.distributortoView}
                distributorDetail={this.props.distributorDetail}
              />

              {(this.props.DistributorsList === undefined ||
                (this.props.DistributorsList &&
                  this.props.DistributorsList.length === 0)) && (
                <div>
                  <div className="noDataImgDiv">
                    <Image
                      className="noDataImg"
                      src={require("../../assets/img/nodata4.png")}
                    />
                  </div>
                  <div className="noDataTextDiv">No Profiles Found</div>
                </div>
              )}
            </div>
          </Card.Body>

          {distributorsPageCount > 1 ? (
            <div className="paginationDiv">
              <ReactPaginate
                forcePage={this.state.page}
                previousLabel={"Prev"}
                nextLabel={"Next"}
                breakLabel={"..."}
                breakClassName={"break-me"}
                pageCount={distributorsPageCount}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                onPageChange={this.handlePageClick}
                containerClassName={"pagination flex-wrap"}
                subContainerClassName={"pages pagination"}
                activeClassName={"active"}
              />
            </div>
          ) : null}
        </Card>
      </div>
    );
  }
}
export default Distributors;
